export const ORDER_DOCUMENT_CODES = ['TRANSPORT', 'PZ', 'WZ', 'PURCHASE_INVOICE', 'SALES_INVOICE', 'TRANSPORT_INVOICE'] as const;
export const ORDER_DOCUMENT_STATES = ['MISSING', 'PARTIAL', 'COMPLETE', 'UNKNOWN'] as const;
export interface OrderDocumentCompleteness {
  checks: Array<{ code: typeof ORDER_DOCUMENT_CODES[number]; state: typeof ORDER_DOCUMENT_STATES[number]; missingCount?: number; totalCount?: number }>;
}
